module.exports = __webpack_public_path__ + "img/icon-time-red.d09b3ba2.svg";